import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class ClearMeasurementsButton extends ToolbarButton {
    constructor(layer) {
        super('eraser', 'Clear Measurements', 'clearBtn');
        this.layer = layer;
    }
    _action() {
        this.layer.clear();
        this.ui.removeClass('highlighted');
    }
}
